import React, { useImperativeHandle, forwardRef, useState } from 'react';
import { Form, Input, Modal, message } from 'antd';
import axios from 'axios';
import { endpoints } from './caminhoApi';

// Componente agora usa forwardRef para ser controlado de fora
const ContactForm = forwardRef((props, ref) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      await axios.post(endpoints.saveContact, values);
      message.success('Mensagem enviada com sucesso!');
      form.resetFields();
      setIsModalOpen(false);
    } catch (err) {
      console.error('Erro ao enviar contato:', err);
      message.error('Erro ao enviar mensagem. Tente novamente.');
    }
  };

  // Expõe a função showModal para o componente pai via ref
  useImperativeHandle(ref, () => ({
    openModal: showModal,
  }));

  return (
    <Modal
      title="Formulario de contacto"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Enviar"
      cancelText="Cancelar"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Nome"
          name="name"
          rules={[{ required: true, message: 'Informe seu nome' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="E-mail"
          name="email"
          rules={[{ required: true, type: 'email', message: 'E-mail inválido' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Mensagem"
          name="message"
          rules={[{ required: true, message: 'Digite sua mensagem' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  );
});

export default ContactForm;